
import React, { Component, PureComponent } from 'react'
import CONSTANTS from '../../constants'
import BodyClassName from 'react-body-classname'

import { connect } from 'react-redux'
import {
  CurrentStepSetAction,
  dealerSetAction,
  bookingSetAction,
  setVeiculeInfos,
  setVeiculeKilo,
  setUploadFiles,
  setCustomerAttachmentId,
  setServices,
  setEditMode,
  selectedServices,
  setCommentServices,
  setPersonalInformations,
  setFilterDealersBy,
  setSelectedPremiumServicesToStore,
  setListPremiumServicesToStore
} from '../../actions/action'
import { Button } from "../Forms/Forms";
import { headTitleTag } from '../../helpers/functions'
import { pushToGTMTracker } from '../../helpers/trackerManager'
import './confirmationPage.css'
import DateHour from "../../images/AC/AC_DateHour.svg"

const mapStateToProps = state => state
const mapDispatchToProps = {
  CurrentStepSetAction,
  dealerSetAction,
  bookingSetAction,
  setVeiculeInfos,
  setVeiculeKilo,
  setUploadFiles,
  setCustomerAttachmentId,
  setServices,
  setEditMode,
  selectedServices,
  setCommentServices,
  setPersonalInformations,
  setFilterDealersBy,
  setSelectedPremiumServicesToStore,
  setListPremiumServicesToStore
}

class ConfirmationPage extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      email: props.store.personalInfos.mail || ''
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    pushToGTMTracker('confirmation-page', window.siteConfig.v2confirmation.Title.replace('[nom-marque]', CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()))

    this.props.dealerSetAction({})
    this.props.bookingSetAction({})
    this.props.setVeiculeInfos({})
    this.props.setVeiculeKilo({})
    this.props.setServices([])
    this.props.setUploadFiles([])
    this.props.setCustomerAttachmentId("")
    this.props.selectedServices([])
    this.props.setCommentServices("");
    this.props.setSelectedPremiumServicesToStore([])
    this.props.setListPremiumServicesToStore([])
    this.props.setFilterDealersBy([])
    this.props.setPersonalInformations({})
    this.props.setEditMode(false)
  }

  render() {
    const SEO_TITLE = (window.siteConfig.v2confirmation != undefined ? window.siteConfig.v2confirmation.Title : '')
    const SEO_DESC = (window.siteConfig.v2confirmation != undefined ? window.siteConfig.v2confirmation.MetaDescription : '')

    return (
      <div className='confirmation-page'>
        {
          headTitleTag(SEO_TITLE.replace('[nom-marque]', CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()),
            SEO_DESC.replace('[nom-marque]', CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()))
        }
        <BodyClassName className='withSummary' />
        <h3 tabIndex="0" className='page-title' dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.confirm_title) }}></h3>
        {CONSTANTS.SITE_INFO.BRAND_CODE === "C" && 
          <img 
            src={DateHour} 
            width={window.isMobile() === "desktop" ? "192" : "96"} 
            style={{
              marginTop : window.isMobile() === "desktop" ? "32px" : "8px",
              marginBottom: window.isMobile() === "desktop" ? "29px" : "8px"
              }} 
          />}
        <div className='container-full-width page-container'>
          <h5 tabIndex="0" className='page-headline' dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.confirm_label1) }}></h5>
          <p className='page-content'>
            <span tabIndex="0" className='page-client_title' dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.confirm_label2) }}></span>
            <span tabIndex="0" className='page-client_email'>{this.state.email}</span>
            <span tabIndex="0" className='page-infos' dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.confirm_label3) }}></span>
          </p>
        </div>
        <div className='container-full-width page-container' style={{ display: "none" }}>
          <h5 tabIndex="0" className='page-headline' dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.confirm_label1) }}></h5>
          <p className='page-content'>
          </p>
          <div className="form-ligne submit-button">
            <Button
              Disabled={this.state.legalChoice}
              onClick={(e) => { (this.validateFormInputs() ? this.setState({ goToNextStep: true }) : this.scrollToTop()) }}
            >
              {CONSTANTS.LABELS.common_v2_nextstep}
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationPage)
